(function () {
  'use strict';

  var section = document.querySelector('[data-collection-section]');
  if (!section) return;

  var sectionId = section.getAttribute('data-section-id');
  var abortCtrl = null;
  var submitTimer = null;

  var qs = function (sel, root) { return (root || document).querySelector(sel); };
  var qsa = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  var isMobile = function () { return window.matchMedia('(max-width: 990px)').matches; };

  // On mobile the filter drawer opens with every group collapsed except
  // "Ideal Para", so it's compact and scannable instead of a giant list.
  var applyMobileCollapse = function () {
    if (!isMobile()) return;
    qsa('[data-filter-group]', section).forEach(function (g) {
      var t = qs('.cafeshi-collection__group-title', g);
      var title = t ? t.textContent.trim().toLowerCase() : '';
      var keepOpen = title.indexOf('ideal') > -1;
      g.classList.toggle('is-collapsed', !keepOpen);
      var head = qs('[data-group-toggle]', g);
      if (head) head.setAttribute('aria-expanded', String(keepOpen));
    });
  };

  // ------------------------------------------------------------------
  // Mobile filter drawer
  // ------------------------------------------------------------------
  var openDrawer = function () {
    applyMobileCollapse();
    section.classList.add('is-filters-open');
    document.body.classList.add('collection-filters-open');
    var toggle = qs('[data-filters-toggle]', section);
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  };
  var closeDrawer = function () {
    section.classList.remove('is-filters-open');
    document.body.classList.remove('collection-filters-open');
    var toggle = qs('[data-filters-toggle]', section);
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  };

  // ------------------------------------------------------------------
  // Price slider — paint fill/readout from current thumb values and keep
  // the hidden (submitting) inputs in sync. Hidden inputs are cleared when
  // they sit at the bounds so the URL param drops.
  // ------------------------------------------------------------------
  // Logarithmic price scale: the thumbs run on a linear position axis (0..SCALE)
  // and map to price exponentially, so the left half of the track covers the
  // low prices (small steps) and the high prices pack into the right.
  var SCALE = 1000;
  var priceFromPos = function (pos, maxP) {
    if (maxP <= 0) return 0;
    return Math.round(Math.pow(maxP + 1, pos / SCALE) - 1);
  };
  var posFromPrice = function (price, maxP) {
    if (maxP <= 0 || price <= 0) return 0;
    return Math.round(SCALE * Math.log(price + 1) / Math.log(maxP + 1));
  };

  var paintSlider = function (root) {
    var min = qs('[data-price-range="min"]', root);
    var max = qs('[data-price-range="max"]', root);
    var fill = qs('[data-price-fill]', root);
    var nMin = qs('[data-price-num="min"]', root);
    var nMax = qs('[data-price-num="max"]', root);
    var hMin = qs('[data-price-input="min"]', root);
    var hMax = qs('[data-price-input="max"]', root);
    if (!min || !max) return;

    var maxP = parseFloat(root.dataset.max) || 0;
    var loPos = parseFloat(min.value) || 0;       // position 0..SCALE
    var hiPos = parseFloat(max.value);
    if (isNaN(hiPos)) hiPos = SCALE;

    // Keep the thumbs from crossing (in position space).
    if (loPos > hiPos) {
      loPos = hiPos;
      min.value = loPos;
    }

    // Fill is linear in position (matches the thumbs).
    if (fill) {
      fill.style.left = (loPos / SCALE) * 100 + '%';
      fill.style.right = (100 - (hiPos / SCALE) * 100) + '%';
    }

    var loPrice = priceFromPos(loPos, maxP);
    var hiPrice = priceFromPos(hiPos, maxP);
    // Mirror the prices into the editable fields — but never clobber the one the
    // user is currently typing in.
    if (nMin && nMin !== document.activeElement) nMin.value = Math.round(loPrice);
    if (nMax && nMax !== document.activeElement) nMax.value = Math.round(hiPrice);

    // Submit the actual prices; drop the param when a thumb sits at its bound.
    if (hMin) hMin.value = loPrice > 0 ? String(loPrice) : '';
    if (hMax) hMax.value = hiPrice < maxP ? String(hiPrice) : '';
  };

  // Set each thumb's position from its initial price, then paint. Run on load
  // and after a body swap (the fresh inputs come back at the 0/SCALE bounds).
  var initSlider = function (root) {
    var min = qs('[data-price-range="min"]', root);
    var max = qs('[data-price-range="max"]', root);
    if (!min || !max) return;
    var maxP = parseFloat(root.dataset.max) || 0;
    var iMin = parseFloat(root.dataset.initMin); if (isNaN(iMin)) iMin = 0;
    var iMax = parseFloat(root.dataset.initMax); if (isNaN(iMax)) iMax = maxP;
    min.value = posFromPrice(iMin, maxP);
    max.value = posFromPrice(iMax, maxP);
    paintSlider(root);
  };

  var paintAllSliders = function () { qsa('[data-price-slider]', section).forEach(initSlider); };

  // Read a slider's typed € fields, clamp them to [0, max] and (on commit) order
  // them, move the thumbs to match and re-paint. `commit` also writes the exact
  // typed prices into the hidden (submitting) inputs and reflects the clamped
  // values back into the fields. Without `commit` it's a live preview while typing.
  var applyNumInputs = function (root, commit) {
    var min = qs('[data-price-range="min"]', root);
    var max = qs('[data-price-range="max"]', root);
    if (!min || !max) return;
    var maxP = parseFloat(root.dataset.max) || 0;
    var nMin = qs('[data-price-num="min"]', root);
    var nMax = qs('[data-price-num="max"]', root);
    var lo = parseFloat(nMin && nMin.value); if (isNaN(lo)) lo = 0;
    var hi = parseFloat(nMax && nMax.value); if (isNaN(hi)) hi = maxP;
    lo = Math.max(0, Math.min(lo, maxP));
    hi = Math.max(0, Math.min(hi, maxP));
    if (commit && lo > hi) { var t = lo; lo = hi; hi = t; }
    min.value = posFromPrice(lo, maxP);
    max.value = posFromPrice(hi, maxP);
    paintSlider(root);
    if (!commit) return;
    // Submit the exact typed prices (paintSlider's log round-trip can drift ±1€).
    var hMin = qs('[data-price-input="min"]', root);
    var hMax = qs('[data-price-input="max"]', root);
    if (hMin) hMin.value = lo > 0 ? String(lo) : '';
    if (hMax) hMax.value = hi < maxP ? String(hi) : '';
    if (nMin) nMin.value = Math.round(lo);
    if (nMax) nMax.value = Math.round(hi);
  };

  // ------------------------------------------------------------------
  // Infinite scroll (SEO-safe): the real pagination links stay in the DOM
  // for crawlers / no-JS; here we lazily fetch the next page when a sentinel
  // near the bottom comes into view and append the cards. No scroll handlers.
  // ------------------------------------------------------------------
  var nextUrl = '';
  var loadingMore = false;
  var infObserver = null;

  var getGrid = function () { return qs('[data-collection-grid]', section); };

  var withSection = function (url) {
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId;
  };

  var loadMore = function () {
    if (!nextUrl || loadingMore) return;
    loadingMore = true;
    section.classList.add('is-loading-more');
    fetch(withSection(nextUrl), { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-collection-grid]');
        var grid = getGrid();
        if (newGrid && grid) {
          var frag = document.createDocumentFragment();
          while (newGrid.firstElementChild) frag.appendChild(newGrid.firstElementChild);
          grid.appendChild(frag);
          nextUrl = newGrid.getAttribute('data-next-url') || '';
          grid.setAttribute('data-next-url', nextUrl);
        } else {
          nextUrl = '';
        }
        loadingMore = false;
        section.classList.remove('is-loading-more');
        if (!nextUrl && infObserver) infObserver.disconnect();
      })
      .catch(function (err) {
        loadingMore = false;
        section.classList.remove('is-loading-more');
        console.error('[collection] load more failed', err);
      });
  };

  var initInfinite = function () {
    var grid = getGrid();
    nextUrl = grid ? (grid.getAttribute('data-next-url') || '') : '';
    if (infObserver) infObserver.disconnect();
    if (!nextUrl) return;
    if (!('IntersectionObserver' in window)) return;
    var sentinel = qs('[data-collection-sentinel]', section);
    if (!sentinel) return;
    infObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) loadMore(); });
    }, { rootMargin: '600px 0px' });
    infObserver.observe(sentinel);
  };

  // ------------------------------------------------------------------
  // Restore the loaded grid + scroll position when returning from a product
  // (only on back/forward navigation; fresh visits render normally).
  // ------------------------------------------------------------------
  var stateKey = function () { return 'cafeshi:collection:' + location.pathname + location.search; };

  var saveState = function () {
    var grid = getGrid();
    if (!grid) return;
    try {
      sessionStorage.setItem(stateKey(), JSON.stringify({
        html: grid.innerHTML,
        next: nextUrl,
        y: window.scrollY || window.pageYOffset || 0
      }));
    } catch (e) { /* quota / disabled — ignore */ }
  };

  var restoreState = function () {
    var raw;
    try { raw = sessionStorage.getItem(stateKey()); } catch (e) { return false; }
    if (!raw) return false;
    var data;
    try { data = JSON.parse(raw); } catch (e) { return false; }
    var grid = getGrid();
    if (!grid || !data || !data.html) return false;
    grid.innerHTML = data.html;
    nextUrl = data.next || '';
    grid.setAttribute('data-next-url', nextUrl);
    var y = data.y || 0;
    requestAnimationFrame(function () {
      window.scrollTo(0, y);
      requestAnimationFrame(function () { window.scrollTo(0, y); });
    });
    return true;
  };

  var isBackForward = function () {
    try {
      var navs = performance.getEntriesByType('navigation');
      if (navs && navs.length) return navs[0].type === 'back_forward';
    } catch (e) { /* fall through */ }
    return !!(performance && performance.navigation && performance.navigation.type === 2);
  };

  // ------------------------------------------------------------------
  // AJAX filtering via the Section Rendering API
  // ------------------------------------------------------------------
  var buildQuery = function () {
    var form = qs('[data-filters-form]', section);
    var params = new URLSearchParams();
    if (!form) return params;
    qsa('input, select', form).forEach(function (el) {
      if (!el.name) return;
      if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
      // Range thumbs don't submit — only their hidden mirrors do.
      if (el.type === 'range') return;
      if (el.value === '') return;
      params.append(el.name, el.value);
    });
    return params;
  };

  var basePath = function () {
    var form = qs('[data-filters-form]', section);
    return (form && form.getAttribute('action')) || window.location.pathname;
  };

  var applyFilters = function (overrideParams) {
    var params = overrideParams || buildQuery();
    var path = basePath();
    var qstr = params.toString();
    var publicUrl = qstr ? path + '?' + qstr : path;

    var fetchUrl = path + '?' + (qstr ? qstr + '&' : '') + 'section_id=' + sectionId;

    var grid = qs('[data-collection-grid]', section);
    if (grid) grid.style.opacity = '0.5';

    // Remember which filter groups the user had collapsed so the swap below
    // doesn't pop them back open.
    var collapsedTitles = qsa('[data-filter-group]', section)
      .filter(function (g) { return g.classList.contains('is-collapsed'); })
      .map(function (g) {
        var t = qs('.cafeshi-collection__group-title', g);
        return t ? t.textContent.trim() : '';
      });

    if (abortCtrl) abortCtrl.abort();
    abortCtrl = new AbortController();

    fetch(fetchUrl, { signal: abortCtrl.signal, headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newBody = doc.querySelector('[data-collection-body]');
        var curBody = qs('[data-collection-body]', section);
        if (newBody && curBody) {
          curBody.innerHTML = newBody.innerHTML;
          paintAllSliders();
          initInfinite();
          qsa('[data-filter-group]', section).forEach(function (g) {
            var t = qs('.cafeshi-collection__group-title', g);
            var title = t ? t.textContent.trim() : '';
            if (collapsedTitles.indexOf(title) > -1) {
              g.classList.add('is-collapsed');
              var head = qs('[data-group-toggle]', g);
              if (head) head.setAttribute('aria-expanded', 'false');
            }
          });
          // The swapped-in toggle button carries the markup's hardcoded
          // aria-expanded="false"; restore it to the real state so its icon
          // (arrow/×) stays correct after a re-render.
          if (typeof syncToggle === 'function') syncToggle();
        }
        if (grid) grid.style.opacity = '';
        history.pushState({ collectionFilters: true }, '', publicUrl);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        console.error('[collection] filter failed', err);
        window.location.href = publicUrl; // fall back to a full reload
      });
  };

  var debouncedApply = function () {
    clearTimeout(submitTimer);
    submitTimer = setTimeout(function () { applyFilters(); }, 250);
  };

  // ------------------------------------------------------------------
  // Delegated events (survive innerHTML swaps of the body)
  // ------------------------------------------------------------------
  section.addEventListener('click', function (e) {
    var groupHead = e.target.closest('[data-group-toggle]');
    if (groupHead && section.contains(groupHead)) {
      var group = groupHead.closest('[data-filter-group]');
      if (group) {
        var collapsed = group.classList.toggle('is-collapsed');
        groupHead.setAttribute('aria-expanded', String(!collapsed));
      }
      return;
    }

    var toggleBtn = e.target.closest('[data-filters-toggle]');
    if (toggleBtn) {
      if (window.matchMedia('(max-width: ' + 990 + 'px)').matches) {
        section.classList.contains('is-filters-open') ? closeDrawer() : openDrawer();
      } else {
        var collapsed = section.classList.toggle('is-filters-collapsed');
        toggleBtn.setAttribute('aria-expanded', String(!collapsed));
      }
      return;
    }
    if (e.target.closest('[data-filters-close]') || e.target.closest('[data-filters-overlay]')) {
      closeDrawer();
      return;
    }

    var moreBtn = e.target.closest('[data-filter-more]');
    if (moreBtn && section.contains(moreBtn)) {
      var body = moreBtn.closest('[data-filter-more-body]');
      if (body) {
        var expanded = body.classList.toggle('is-expanded');
        moreBtn.setAttribute('aria-expanded', String(expanded));
        var lbl = qs('.cafeshi-collection__more-label', moreBtn);
        if (lbl) lbl.textContent = expanded ? 'Mostrar menos' : 'Mostrar más';
      }
      return;
    }

    var clear = e.target.closest('[data-filters-clear]');
    if (clear) {
      e.preventDefault();
      applyFilters(new URLSearchParams());
      return;
    }
  });

  section.addEventListener('submit', function (e) {
    if (e.target.closest('[data-filters-form]')) {
      e.preventDefault();
      // Commit any typed € fields (Enter) before building the query.
      qsa('[data-price-slider]', section).forEach(function (r) { applyNumInputs(r, true); });
      clearTimeout(submitTimer);
      applyFilters();
    }
  });

  // Live painting while dragging the thumbs or typing in the € fields; the
  // commit (change) is what actually runs the filter.
  section.addEventListener('input', function (e) {
    if (e.target.matches('[data-price-range]')) {
      paintSlider(e.target.closest('[data-price-slider]'));
    } else if (e.target.matches('[data-price-num]')) {
      applyNumInputs(e.target.closest('[data-price-slider]'), false);
    }
  });

  section.addEventListener('change', function (e) {
    var t = e.target;
    if (!t.closest('[data-filters-form]')) return;
    if (t.matches('[data-price-range]')) {
      paintSlider(t.closest('[data-price-slider]'));
      debouncedApply();
      return;
    }
    if (t.matches('[data-price-num]')) {
      applyNumInputs(t.closest('[data-price-slider]'), true);
      debouncedApply();
      return;
    }
    if (t.matches('.cafeshi-collection__checkbox, .cafeshi-collection__radio')) {
      // Availability behaves like a radio: "En existencia" and "Agotado" can't
      // both be active, and one is ALWAYS active (the grid defaults to
      // in-stock). Clicking the already-active pill would uncheck it, but the
      // re-render re-checks it by default — leaving the UI active while the grid
      // silently shows everything. So treat un-checking as a no-op.
      if (t.name === 'filter.v.availability') {
        if (!t.checked) { t.checked = true; return; }
        var form = t.closest('[data-filters-form]');
        qsa('input[name="filter.v.availability"]', form).forEach(function (o) {
          if (o !== t) o.checked = false;
        });
      }
      applyFilters();
    }
  });

  window.addEventListener('popstate', function () {
    // Re-sync to whatever the URL now says (back/forward navigation).
    var params = new URLSearchParams(window.location.search);
    applyFilters(params);
  });

  // Keep the "Filtrar y ordenar" toggle's aria-expanded in sync with the real
  // state so its icon (arrow = can expand · × = can close) is right on load,
  // after crossing the mobile/desktop breakpoint, AND after each body re-render
  // (applyFilters swaps innerHTML of [data-collection-body], which contains the
  // toggle and would otherwise reset it to the markup's hardcoded "false").
  var syncToggle = function () {
    var toggleBtn = qs('[data-filters-toggle]', section);
    if (!toggleBtn) return;
    var open = window.matchMedia('(max-width: 990px)').matches
      ? section.classList.contains('is-filters-open')
      : !section.classList.contains('is-filters-collapsed');
    toggleBtn.setAttribute('aria-expanded', String(open));
  };
  syncToggle();
  window.addEventListener('resize', syncToggle);

  // Default to "En existencia": when the URL carries no availability filter and
  // the in-stock box is checked by default (see main-collection.liquid), apply
  // it so the collection shows in-stock products by default.
  (function () {
    if (new URLSearchParams(window.location.search).has('filter.v.availability')) return;
    var form = qs('[data-filters-form]', section);
    var box = form && form.querySelector('input[name="filter.v.availability"][value="1"]');
    if (box && box.checked) applyFilters();
  })();

  // Persist grid + scroll before leaving (e.g. clicking into a product).
  window.addEventListener('pagehide', saveState);
  section.addEventListener('click', function (e) {
    if (e.target.closest('[data-collection-grid] a[href]')) saveState();
  }, true);

  // ------------------------------------------------------------------
  // Sticky subcategory bar — pins under the header and slides its tabs to
  // centre. The slide is animated with a FLIP transform on the track.
  // ------------------------------------------------------------------
  var subNav = qs('[data-subcats]', section);
  var subTrack = qs('[data-subcats-track]', section);
  var subObserver = null;
  var subStuck = false;
  var subResizeTimer = null;

  var subInner = qs('.cafeshi-collection__inner', section);

  // Hide the subcategory tabs that don't fit on a single row (desktop only;
  // on mobile the bar scrolls horizontally so every tab stays reachable).
  var fitSubcats = function () {
    if (!subTrack) return;
    var tabs = qsa('.cafeshi-collection__subcat', subTrack);
    tabs.forEach(function (t) { t.style.display = ''; });
    if (window.matchMedia('(max-width: 990px)').matches || !subInner) return;

    var cs = getComputedStyle(subInner);
    var budget = subInner.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0);
    var gap = 8;
    var used = 0;
    var over = false;
    tabs.forEach(function (t) {
      var active = t.classList.contains('is-active');
      if (over && !active) { t.style.display = 'none'; return; }
      var w = t.offsetWidth;
      var next = used === 0 ? w : used + gap + w;
      if (next > budget && !active) {
        t.style.display = 'none';
        over = true;
      } else {
        used = next;
      }
    });
  };

  var setSubStuck = function (stuck) {
    if (!subNav || !subTrack || stuck === subStuck) return;
    var first = subTrack.getBoundingClientRect().left;
    subNav.classList.toggle('is-stuck', stuck);
    subStuck = stuck;
    var delta = first - subTrack.getBoundingClientRect().left;
    if (!delta) return;
    subTrack.style.transition = 'none';
    subTrack.style.transform = 'translateX(' + delta + 'px)';
    requestAnimationFrame(function () {
      subTrack.style.transition = 'transform 0.4s cubic-bezier(0.22, 1, 0.36, 1)';
      subTrack.style.transform = '';
    });
  };

  var initSubcats = function () {
    fitSubcats();
    var headerEl = document.querySelector('.shopify-section--header');
    var headerH = headerEl ? Math.round(headerEl.getBoundingClientRect().height) : 0;
    section.style.setProperty('--subcats-top', headerH + 'px');
    // Height of the bar in its stuck state (tabs + 12px top/bottom padding),
    // used to offset the sticky filter sidebar so they don't overlap.
    var barH = subTrack ? Math.round(subTrack.getBoundingClientRect().height) + 24 : 0;
    section.style.setProperty('--subcats-h', barH + 'px');

    if (!subNav) return;
    if (subObserver) subObserver.disconnect();
    // Observe the bar itself: while it's fully below the header line ratio is 1;
    // once it pins under the header its top crosses that line and ratio drops.
    subObserver = new IntersectionObserver(function (entries) {
      setSubStuck(entries[0].intersectionRatio < 1);
    }, { rootMargin: '-' + (headerH + 1) + 'px 0px 0px 0px', threshold: [1] });
    subObserver.observe(subNav);
  };

  window.addEventListener('resize', function () {
    clearTimeout(subResizeTimer);
    subResizeTimer = setTimeout(initSubcats, 150);
  });

  // ------------------------------------------------------------------
  // Init
  // ------------------------------------------------------------------
  section.classList.add('js-infinite');
  paintAllSliders();
  if (isBackForward()) restoreState();
  initInfinite();
  initSubcats();
  applyMobileCollapse();
})();
